import {
  createAsyncThunk,
  createSlice,
  isAsyncThunkAction,
} from "@reduxjs/toolkit";
import { RootState } from "app.store";
import { setLogin } from "states/global-value/global-value.slice";
import { getCustomerAddressesAPI } from "./customer-address.api";
import {
  ICustomerAddressModel,
  ICustomerAddressState,
} from "./customer-address.models";

export const fetchCustomerAddresses = createAsyncThunk<
  ICustomerAddressModel[],
  void,
  {}
>(
  "customer_addresses/getAllCustomerAddress",
  async (thunkAPI, { rejectWithValue, dispatch }) => {
    try {
      const res = await getCustomerAddressesAPI();
      dispatch(setLogin());
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.error?.message);
    }
  }
);

export const customerAddressSlice = createSlice({
  name: "customerAddress",
  initialState: {
    addresses: [],
  } as ICustomerAddressState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      isAsyncThunkAction(fetchCustomerAddresses),
      (state, action) => {
        if (action.meta.requestStatus === "fulfilled") {
          state.addresses = action.payload as ICustomerAddressModel[];
        }
      }
    );
  },
});

export const selectCustomerAddresses = (state: RootState) =>
  state.customerAddress.addresses;
